import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { formatGigaBytes } from "helpers/numberFormatting";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { getBaremetalDetails } from "redux/selectors/baremetalSelector";

const BaremetalDetails = () => {
 const baremetal = useSelector(getBaremetalDetails);

 return (
  <Stack>
   <Stack direction="row" spacing={1}>
    <Typography variant="caption" fontWeight="bold">
     <FormattedMessage id="baremetal.diskType" />:
    </Typography>
    <Typography variant="caption">{baremetal?.disk_type}</Typography>
   </Stack>
   <Stack direction="row" spacing={1}>
    <Typography variant="caption" fontWeight="bold">
     <FormattedMessage id="baremetal.disk" />:
    </Typography>
    <Typography variant="caption">
     {(baremetal?.dim_disk || 0) >= 1024
      ? `${formatGigaBytes(baremetal?.dim_disk || 0, "TB")} TB`
      : `${formatGigaBytes(baremetal?.dim_disk || 0)} GB`}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={1}>
    <Typography variant="caption" fontWeight="bold">
     RAM:
    </Typography>
    <Typography variant="caption">{`${baremetal?.dim_ram} GB`}</Typography>
   </Stack>
  </Stack>
 );
};

export default BaremetalDetails;
